import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 9.1 — Tour del flujo POS (toma de pedido).
 *
 * Diseñado para correr cuando el usuario ya está en la fase 'menu'
 * (con productos visibles y carrito a la derecha). Cubre el camino
 * normal "Comer aquí → Menú → Carrito → Confirmar".
 */
export const tourPos: TourDefinition = {
  id: 'pos',
  title: 'Cómo levantar un pedido',
  steps: [
    {
      element: '[data-tour="pos-header"]',
      popover: {
        title: '1. ¿Dónde estás?',
        description:
          'Esta barra te dice qué tipo de venta estás haciendo y en qué mesa. Si te equivocas, usa la flecha de la izquierda para regresar.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="pos-menu"]',
      popover: {
        title: '2. El menú',
        description:
          'Toca cualquier producto o paquete para agregarlo al pedido. Los paquetes (Espadas) abren una ventana donde eliges los cortes.',
        side: 'right',
      },
    },
    {
      element: '[data-tour="pos-carrito"]',
      popover: {
        title: '3. El carrito',
        description:
          'Aquí ves lo que llevas. Puedes cambiar la cantidad con + / − o quitar items. El total se calcula solo.',
        side: 'left',
      },
    },
    {
      element: '[data-tour="pos-carrito-confirmar"]',
      popover: {
        title: '4. Confirmar el pedido',
        description:
          'Cuando termines de capturar, toca "Confirmar". El pedido se envía a cocina y aparece la pantalla de cobro.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="pos-carrito-cancelar"]',
      popover: {
        title: '5. Cancelar (si te equivocaste)',
        description:
          'Si todavía no confirmaste, puedes cancelar todo desde aquí. No pasa nada — el carrito se vacía y vuelves al inicio.',
        side: 'top',
      },
    },
  ],
};
